import axios from 'axios'
import { priceListUrl, priceListGroupUrl, getHeader } from './../config'

const state = {
  priceListGroup: [],
  priceList: []
}

const mutations = {
  SET_PRICE_LIST (state, obj) {
    state.priceList = obj
  },
  SET_PRICE_LIST_GROUP (state, obj) {
    state.priceListGroup = obj
  }
}

const actions = {
  getPriceList: ({ commit }) => {
    axios.get(priceListUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PRICE_LIST', response.data.data)
      })
  },
  getPriceListGroup: ({ commit }) => {
    axios.get(priceListGroupUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PRICE_LIST_GROUP', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
